import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { services } from '../data/services';
export function Services() {
  return <section id="services" className="bg-white" data-id="element-195" data-mp="1hwxi8898a6fg">
      <div className="mx-auto max-w-6xl px-6 py-20 lg:py-28" data-id="element-196" data-mp="1dtsk0hw6kqwm">
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-end" data-id="element-197" data-mp="1ds7qmvllre0c">
          <h2 className="text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-198" data-mp="18u65m54m94m8">
            Six ways we make a property look after itself.
          </h2>
          <p className="max-w-lg text-base leading-relaxed text-neutral-600 lg:justify-self-end" data-id="element-199" data-mp="z5eicaai38hn">
            Every surface gets a different approach — soft wash where pressure
            would do damage, and real pressure where it won't.
          </p>
        </div>

        <ul className="mt-14 border-t border-neutral-200" data-id="element-200" data-mp="q2dekg93xth5">
          {services.map((service, index) => <li key={service.name} className="border-b border-neutral-200" data-id="element-201" data-mp="l77u7lvcsmv6" data-mpi={index}>
              <a href="#quote" className="group grid items-baseline gap-2 py-7 transition-colors hover:bg-neutral-50 sm:grid-cols-[3.5rem_1fr_1.4fr_2rem] sm:gap-6 sm:px-2" data-id="element-202" data-mp="g729kpni40ml">
                <span className="font-mono text-xs text-neutral-400" data-id="element-203" data-mp="3b50xf4f6ed3y">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="text-lg font-semibold tracking-tight text-ink" data-id="element-204" data-mp="32bxmp3vx0ed0">
                  {service.name}
                </h3>
                <p className="text-sm leading-relaxed text-neutral-600" data-id="element-205" data-mp="3q18dptngqudy">
                  {service.description}
                </p>
                <ArrowUpRight className="h-5 w-5 text-neutral-300 transition-colors group-hover:text-gold-dark sm:justify-self-end" aria-hidden="true" data-id="element-206" data-mp="3g29e10koe933" />
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}